import { render } from "./SidebarTrial.vue?vue&type=template&id=f3e35c3a"
import script from "./SidebarTrial.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarTrial.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/SidebarTrial.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f3e35c3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f3e35c3a', __exports__)) {
    api.reload('f3e35c3a', __exports__)
  }
  
  module.hot.accept("./SidebarTrial.vue?vue&type=template&id=f3e35c3a", () => {
    api.rerender('f3e35c3a', render)
  })

}


export default __exports__